import React from "react";
import { Shell } from "./UI";

export default function StaticPage({ route, onBack }) {
  const content = {
    faq: {
      title: "FAQ",
      body: [
        {
          q: "What is included with Exam Practice App?",
          a: "Full access to NMLS questions, explanations, and progress tracking in Exam Practice App.",
        },
        {
          q: "How do monthly and 3-month plans work?",
          a: "Both plans are one-time access. The 1-month plan gives 30 days of access, and the 3-month plan gives 90 days. There is no auto-renewal.",
        },
        {
          q: "I paid but cannot log in. What should I do?",
          a: "Make sure you log in with the same email used at checkout. If it still fails, contact support with your payment email.",
        },
        {
          q: "Can I switch plans?",
          a: "Yes. Purchase the new plan and your access will be updated. Contact support if you need help aligning dates.",
        },
        {
          q: "Do you offer refunds?",
          a: "We do not offer refunds.",
        },
      ],
    },
    contact: {
      title: "Contact Us",
      body:
        "Email support@alerainfotech.com for help with login, billing, or content access.",
    },
    privacy: {
      title: "Privacy",
      body:
        "We respect your privacy and only use your data to provide access to your practice content.",
    },
    copyright: {
      title: "Copyright",
      body:
        "All content is owned by BuyDeepDiscount.com LLC. Unauthorized distribution is prohibited.",
    },
  };

  const page = content[route] || {
    title: "Page",
    body: "This page is not available.",
  };

  return (
    <Shell>
      <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-950">
        <div className="w-full max-w-2xl rounded-3xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg p-8">
          <div className="text-sm text-slate-500 dark:text-slate-400 mb-4">
            <button
              type="button"
              onClick={onBack}
              className="text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300"
            >
              ← Back
            </button>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-3">{page.title}</h1>
          {Array.isArray(page.body) ? (
            <div className="space-y-4 text-slate-600 dark:text-slate-300">
              {page.body.map((item) => (
                <div key={item.q}>
                  <div className="font-semibold text-slate-900 dark:text-white">{item.q}</div>
                  <p className="leading-relaxed">{item.a}</p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-slate-600 dark:text-slate-300 leading-relaxed">{page.body}</p>
          )}
        </div>
      </div>
    </Shell>
  );
}
